// extracted by mini-css-extract-plugin
module.exports = {"bio":"Bio-styles--bio--19O1N","bioPic":"Bio-styles--bio-pic--3obCu","bioDescription":"Bio-styles--bio-description--1ii-U"};